import { UserStatus } from '../../enums';

export interface CreateUserPayloadOptions {
  isLoggedIn: boolean | null | undefined;
  qffHashId: string | null | undefined;
  qffPoints: number | null | undefined;
  userId: string;
}

export interface CreateUserPayloadReturn {
  user_id: string;
  user_login_status: UserStatus;
  user_points: number | null | undefined;
  user_qff_hash: string | null | undefined;
}

export const createUserPayload = ({ userId, qffHashId, isLoggedIn, qffPoints }: CreateUserPayloadOptions): CreateUserPayloadReturn => {
  return {
    user_id: userId,
    user_qff_hash: qffHashId,
    user_login_status: isLoggedIn ? UserStatus.LOGGED_IN : UserStatus.LOGGED_OUT,
    user_points: qffPoints,
  };
};
